export default __webpack_public_path__ + "static/media/question.fd45941e.png";